export const BASE_API_URL = "https://uat.1800accountant.com/";

export const APIS = {
    LOGIN: "payroll_org/limited_access/employee/login",
    EMPLOYEE: "payroll_org/limited_access/employee",
    LOGOUT: "payroll_org/limited_access/employee/logout",
    FEDERAL_TAXES: "payroll_org/limited_access/employee/federal_taxes",
    CONFIG: "/config/payroll_org/limited_access",
    GET_ALL_DETAILS: "payroll_org/limited_access/employee/all_details",
    GET_ALL_FORMS: "payroll_org/limited_access/employee/forms",
    SIGN: "payroll_org/limited_access/employee/form/{uuid}/sign",
    TOS: "payroll_org/limited_access/employee/tos",
    ONBOARDING_STEPS:
        "payroll_org/limited_access/employee/onboarding_steps_info",
    FINISH_ONBOARDING: "payroll_org/limited_access/employee/finish_onboarding",
    UPDATE_ADDRESS: "payroll_org/limited_access/employee/address",
    GET_AND_UPDATE_PAYMENT_METHOD:
        "payroll_org/limited_access/employee/payment_method",
    CREATE_AND_GET_BANK_ACCOUNT:
        "payroll_org/limited_access/employee/bank_account",
    GET_PDF: "payroll_org/limited_access/employee/form/{uuid}/pdf",
    STATE_TAXES: "payroll_org/limited_access/employee/state_tax",
    GET_TOS_STATUS: "payroll_org/limited_access/employee/tos_status",
    INVALIDATE_TOKEN: "payroll_org/limited_access/employee/invalidate",
};

export const ADP_APIS = {
    EMPLOYEE: "payroll_org/limited_access/adp/employee",
};
